import React, { useContext } from 'react';

import {
    Card,
    ListGroup,
    Accordion
} from 'react-bootstrap';

import {
    ReportingDataContext
} from '../libs/contexts.js';

export const Releases = ({ }) => {
    const { reportingData } = useContext(ReportingDataContext);


    return (
        <>
            <h3>Release notes</h3>
            <Accordion defaultActiveKey="0">
                {reportingData.releasenotes?.map((release, releaseIndex) => (
                    <Accordion.Item eventKey={releaseIndex.toString()} key={releaseIndex}>
                        <Accordion.Header>{release.date}</Accordion.Header>
                        <Accordion.Body>
                            <ListGroup variant="flush">
                                {release.notes?.map((note, noteIndex) => (
                                    <ListGroup.Item className='mb-2' key={noteIndex}>
                                        <Card.Title as={'h3'}><strong>{noteIndex + 1}. {note.note_title}</strong></Card.Title>
                                        {note.note?.map((item, itemIndex) => (
                                            <React.Fragment key={itemIndex}>
                                                <Card.Subtitle className='mt-4 mb-4' as={'h5'}><strong>{item.title}</strong></Card.Subtitle>
                                                <Card.Text className="text-muted mb-2"><strong>Description: </strong>{item.description}</Card.Text>
                                                <Card.Text className="text-muted mb-2"><strong>Benefits: </strong></Card.Text>
                                                {item.benefits?.map((benefit, benefitIndex) => (
                                                    <Card.Text className="text-muted mb-2" key={benefitIndex}>&#x2022; {benefit}</Card.Text>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </>

    );
}